import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";

// BẮT BUỘC set worker (dùng CDN cho đỡ lỗi bundler)
(pdfjsLib as any).GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

export default pdfjsLib;
